import { FEATURE_GATES, FeatureGateKey } from '@src/configs/feature_gates'
import { Environment } from '@src/configs/feature_gates'

// Check if a feature is enabled for the current environment
export const isFeatureEnabled = (feature: FeatureGateKey): boolean => {
    const currentEnv = process.env.REACT_APP_FEATURE_GATE_ENV?.toUpperCase() || ''
    const enabledEnvs = FEATURE_GATES[feature] || []
    return enabledEnvs.includes(currentEnv as Environment)
}
